let localizeTrixEditor = function (lang) {
 switch (lang) {
     case "cs":
     case "cs-cz":
     case "cs_CZ":
         Trix.config.lang.bold = "Tučný"+lang;
         Trix.config.lang.italic = "Kurzíva";
         Trix.config.lang.strike = "Přeškrtnutý";
         Trix.config.lang.bullets = "Odrážky";
         Trix.config.lang.numbers = "Číslovaný seznam";
         Trix.config.lang.indent = "Zvětšit odsazení";
         Trix.config.lang.outdent = "Zmenšit odsazení";
         Trix.config.lang.undo = "Zpět";
         Trix.config.lang.redo = "Znovu";
         break;
     default:
         break;
 }
}